import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { IconButton, CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { s3baseUrl } from "../../config/config";
import { ReactVideoPlayer } from "src/components";
import { useSnackbar } from "notistack";
import {
  StudySessionRecordingDetailApi,
  LessonRecordingDetail,
} from "../../DAL/Programmes/Programmes";
import { makeStyles } from "@mui/styles";
import { htmlDecode } from "src/utils/convertHtml";
const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

function StudySessionRecordingDetail(props) {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [recordingData, seRecordingData] = React.useState({});
  const handleNavigate = () => {
    navigate(-1);
  };

  const getSessionRecordingDetail = async () => {
    setIsLoading(true);
    const result = await StudySessionRecordingDetailApi(params.recording_slug);
    if (result.code === 200) {
      seRecordingData(result.study_session_recording);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      navigate(`/programmes`);
    }
  };

  useEffect(() => {
    getSessionRecordingDetail();
  }, [params.recording_slug]);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <div className="container">
      <div className="row mobile-margin display-flex">
        <div className="col-12">
          <IconButton
            className="back-screen-button"
            onClick={() => handleNavigate()}
          >
            <ArrowBackIcon />
          </IconButton>
        </div>
      </div>

      <div className="row section-space">
        <div className="col-12">
          <h1 className="programmes-heading">
            {htmlDecode(recordingData.title)}
          </h1>
        </div>
      </div>
      <div className="row media-margin">
        <div className="col-12">
          <ReactVideoPlayer url={recordingData.video_url} />
        </div>
        <div className="col-12 section-space">
          <p
            dangerouslySetInnerHTML={{
              __html: recordingData.detailed_description,
            }}
          ></p>
        </div>
      </div>
    </div>
  );
}

export default StudySessionRecordingDetail;
